<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

interface Props {
  defaultState: string
  modelValue: boolean
}

const prop = withDefaults(defineProps<Props>(), {
  modelValue: false,
  defaultState: 'login'
})

const emit = defineEmits(['update:modelValue', 'update:defaultState'])

const visible = computed({
  get() {
    return prop.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

const { t: $t } = useI18n()
const state = ref(prop.defaultState)
watch(() => prop.modelValue, (open) => {
  if (open) state.value = prop.defaultState
})

const titleText = computed(() => {
  switch (state.value) {
    case 'signup':
      return $t('login.signup_button')
    case 'login':
      return $t('login.button')
    case 'reset':
      return $t('login.reset.button')
    default:
      return ''
  }
})
</script>

<template lang="pug">
div
  Dialog(v-model:open="visible")
    DialogTrigger(v-if="$slots.default")
      slot
    DialogContent(class="w-[calc(100vw-2rem)] max-w-[420px] overflow-y-auto [&>button]:z-10 rounded-2xl border-0 p-0 gap-0 sm:rounded-2xl" :style="{ backgroundColor: 'transparent' }")
      DialogTitle.sr-only {{ titleText }}
      DialogDescription.sr-only {{ $t('login.secure_connection') }}
      LoginPanel(v-model="state" embedded)
</template>
